export default __webpack_public_path__ + "static/media/circle.7bd3fe55.png";